module.exports = __webpack_public_path__ + "static/media/goat-image.a3304c72.png";